import { signIn } from 'next-auth/react';
import { useCallback, useState } from 'react';
import { useBodyScrollLock } from '@/hooks/use-body-scroll-lock';
import { useCloseModalOnNavigation } from '@/hooks/use-close-modal-on-navigation';
import { sendTrackingUserAuth } from '@/lib/tracking/events';
import { useAuthenticationContext } from '@/providers/auth-provider';

type ActiveModal = 'register' | 'login' | 'notification' | null;

export const useAuthModal = () => {
  const { login, loginDisabled, startIdpResolve } = useAuthenticationContext();
  const [activeModal, setActiveModal] = useState<ActiveModal>(null);

  const closeAuthModal = useCallback(() => setActiveModal(null), []);

  useBodyScrollLock(activeModal !== null);
  useCloseModalOnNavigation(activeModal !== null, closeAuthModal);

  const handleIdpSignIn = () => {
    closeAuthModal();

    const callbackUrl = window.location.pathname + window.location.search;
    try {
      sessionStorage.setItem('pending_idp_resolve', 'direct');
      sessionStorage.setItem('idp_resolve_callback_url', callbackUrl);
    } catch {
      // sessionStorage が使えない環境では無視
    }
    signIn('livenode', { redirectTo: callbackUrl });
  };

  const handleStartMigration = () => {
    sendTrackingUserAuth('user_auth_menu');
    closeAuthModal();
    startIdpResolve('migration');
    login();
  };

  return {
    activeModal,
    setActiveModal,
    closeAuthModal,
    handleIdpSignIn,
    handleStartMigration,
    loginDisabled,
  };
};
